export default __webpack_public_path__ + "static/img-automatic-0bf900f39fdea554351ec6c85282836d.png";